import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentData = styled.div`
  width: 916px;
  height: 100%;
  margin-top: 25%;
  margin-left: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: #FCFCFD;
  padding: 1rem;
  position:relative;
  z-index:1;

  .cardShowValue {
    background: ${(props) => props.theme.white};
    border-radius: 8px;
    padding: 1rem;
    width: 100%;
    /* max-width: 343px; */
    height: 100%;
    max-height: 210px;
    display: flex;
    flex-direction: column;
    box-shadow: ${(props) => props.theme['card-shadow-2']};

    h3 {
      margin: 0;
    }

    p {
      margin: 0;
      font: 400 1rem 'Poppins', sans-serif;
      line-height: 1.8;
      color: #6A717E;
    }
    strong {
      margin: 0;
      font: 400 1rem 'Poppins', sans-serif;
      line-height: 1.8;
      color: #1a1a1a;
    }
  }

  .contentFilter {
    display: flex;
    gap: 1rem;
    padding: 1rem 0.5rem;
    background: ${(props) => props.theme.white};
    border-radius: 8px;
    margin-bottom: 1rem;

    p {
      font-size: 16px;
      font-weight: bold;
      color: ${(props) => props.theme.black};
      cursor: pointer;
      margin: 0;
    }
    .activeFilter {
      color: ${(props) => props.theme.primary};
      border-bottom: 2px solid ${(props) => props.theme.primary};
    }
  }
  .finalList {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;

    h3 {
      font: 400 0.75rem 'Poppins', sans-serif;
      color: ${(props) => props.theme.primary};
      cursor: pointer;
      transition: filter 0.3s;
      :hover {
        filter: brightness(0.9);
      }
    }
  }
`;
export const HeaderDate = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  background: ${(props) => props.theme.white};
  border-radius: 4px;
  padding: 1rem;
  align-items: center;
  box-shadow: ${(props) => props.theme['card-shadow-2']};

  h3 {
    margin: 0;
    font: 500 1rem 'Poppins', sans-serif;
  }

  div {
    display: flex;
    flex-direction: row;
    gap: 3rem;
    align-items: center;

    span {
      width: auto;
    }
    @media (max-width: 480px) {
      gap: 0;
    }
  }

  @media (max-width: 340px) {
    gap: 1rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  width: 100%;
  align-items: start;

  .filterButton {
    all: unset;
    box-shadow: 1px 1px 6px 0px #0000001a;
    border-radius: 99999px;
    background: ${(props) => props.theme.white};
    font-size: 2rem;
    padding: 0.5rem 0.75rem;
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0;
  }
`;
